import { Stack, Space } from "@mantine/core";
import { Button } from "@/components/ui/Button";
import { Text } from "@/components/ui/Text";
import { Title } from "@/components/ui/Title";
import { IconArrowRight } from "@tabler/icons-react";
import { Navigation } from "@/services/Navigation";
import { Analytics } from "@/services/Analytics";
import { useIsLaptopOrBigger } from "@/styles/useStyles";

export function VideoLoginPrompt({
  isPlaylistVideo = false,
}: {
  isPlaylistVideo?: boolean;
}) {
  const isLaptopOrBigger = useIsLaptopOrBigger();

  const handleSignIn = () => {
    Analytics.click({
      action: "Video Login Prompt > Sign in clicked",
      context: isPlaylistVideo ? "playlist" : "video",
    });
    Navigation.navToLogin();
  };

  return (
    <Stack
      w="100%"
      h="100%"
      pos="absolute"
      top={0}
      bottom={0}
      right={0}
      left={0}
      gap="lg"
      style={{ zIndex: 2 }}
      justify="center"
      align="center"
      bg="rgba(255, 255, 255, 0.95)"
      px="xl"
      py="xl"
    >
      <Stack gap={0} align="center">
        <Title order={isLaptopOrBigger ? 3 : 4} ta="center" c="primary.9">
          {isPlaylistVideo
            ? "Sign in to start this playlist"
            : "Sign in to watch this video"}
        </Title>
        <Space h="xs" />
        <Text ta="center" c="text.6" size="sm" maw={400}>
          {isPlaylistVideo
            ? "Create a free account to track your progress, save playlists, and get personalized recommendations."
            : "Create a free account to watch videos, track your progress, and get personalized recommendations."}
        </Text>
      </Stack>

      <Stack gap="sm" w="100%" maw={300}>
        <Button
          variant="filled"
          onClick={handleSignIn}
          size={isLaptopOrBigger ? "md" : "sm"}
          color="primary"
          radius="xl"
          fullWidth
          rightSection={<IconArrowRight size={isLaptopOrBigger ? 20 : 18} />}
        >
          Sign in or create account
        </Button>
        <Text ta="center" c="text.5" size="xs">
          It's free and takes less than a minute
        </Text>
      </Stack>
    </Stack>
  );
}
